/* Club 1984 - quick add on product cards (snippets/c84-quick-add.liquid).
 *
 * Tap the + to show sizes, tap a size to add it. Single-variant products add
 * from the + itself. Delegated from the document, so cards loaded later
 * (filtering, infinite scroll, recommendations) work without rebinding.
 *
 * The add is the same one the theme's product form makes: it asks Shopify for
 * the header and drawer sections, swaps them in, then opens the drawer.
 */
(function () {
  if (window.c84QuickAddBound) return;
  window.c84QuickAddBound = true;

  var hoverDevice = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function close(qa) {
    if (!qa) return;
    qa.classList.remove('is-open');
    var btn = qa.querySelector('[data-c84-qa-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  function closeAll(except) {
    document.querySelectorAll('[data-c84-qa].is-open').forEach(function (qa) {
      if (qa !== except) close(qa);
    });
  }
  function open(qa) {
    closeAll(qa);
    qa.classList.add('is-open');
    var btn = qa.querySelector('[data-c84-qa-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function track(data, variantId) {
    try {
      var value = (data.final_line_price != null ? data.final_line_price : data.price || 0) / 100;
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart', source: 'quick_add', currency: currency, value: value,
        items: [{ item_id: String(data.variant_id || data.id || variantId), item_name: data.product_title || '', item_variant: data.variant_title || '', item_list_name: 'product card quick add', price: value, quantity: 1 }]
      });
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('c84_add_to_cart', { source: 'quick_add', variant_id: String(data.variant_id || data.id || variantId), title: data.product_title || '', value: value, currency: currency });
      }
    } catch (e) { /* never let tracking stop a sale */ }
  }

  /* Marks the order, so the weekly report can count orders that used quick
     add. Underscore attributes are hidden from the customer at checkout but
     kept on the order. Once per session is enough. */
  function markCart() {
    try {
      if (sessionStorage.getItem('c84QaMarked')) return;
      sessionStorage.setItem('c84QaMarked', '1');
    } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _quick_add: 'yes' } })
    }).catch(function () {});
  }

  async function add(btn) {
    if (btn.classList.contains('is-busy')) return;
    var qa = btn.closest('[data-c84-qa]');
    btn.classList.add('is-busy');

    var els = ['page-header', 'cart-drawer']
      .map(function (s) { return document.querySelector(s); })
      .filter(function (el) { return el && el.dataset.sectionId; });

    var body = new FormData();
    body.append('id', btn.dataset.variantId);
    body.append('quantity', 1);
    if (els.length) {
      body.append('sections_url', window.location.pathname);
      body.append('sections', els.map(function (el) { return el.dataset.sectionId; }).join(','));
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      });
      var data = await res.json();
      if (!res.ok) throw new Error(data && data.description || res.status);

      track(data, btn.dataset.variantId);

      if (!document.querySelector('cart-drawer')) { window.location.href = root + 'cart'; return; }
      if (data.sections && els.length === Object.keys(data.sections).length) {
        els.forEach(function (el) { el.updateFromCartChange(data.sections[el.dataset.sectionId]); });
      } else {
        btn.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }
      btn.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { source: 'quick_add', item: data } }));

      close(qa);
      if (btn.matches('.c84-qa__plus')) {
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1500);
      }
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      markCart();
    } catch (err) {
      /* Usually stock: the size sold out since the page loaded. Let the
         product page explain rather than failing silently. */
      var link = qa && qa.closest('.image-cont') && qa.closest('.image-cont').querySelector('a.product-link');
      if (link && window.confirm('Sorry, we could not add that size. View the product?')) window.location.href = link.href;
    } finally {
      btn.classList.remove('is-busy');
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var qa = t.closest('[data-c84-qa]');

    if (!qa) { closeAll(); return; }

    /* Keep the card's own link and the theme's quick buy from seeing this. */
    e.preventDefault();
    e.stopPropagation();

    if (t.closest('[data-c84-qa-close]')) { close(qa); return; }
    if (t.closest('[data-c84-qa-open]')) { qa.classList.contains('is-open') ? close(qa) : open(qa); return; }
    var addBtn = t.closest('[data-c84-qa-add]');
    if (addBtn) add(addBtn);
  }, true);

  /* Desktop, as on Represent: hovering the + shows the sizes, leaving the
     photo hides them. */
  if (hoverDevice) {
    document.addEventListener('mouseover', function (e) {
      var plus = e.target.closest && e.target.closest('[data-c84-qa-open]');
      if (plus) open(plus.closest('[data-c84-qa]'));
    });
    document.addEventListener('mouseout', function (e) {
      var cont = e.target.closest && e.target.closest('.image-cont');
      if (!cont || cont.contains(e.relatedTarget)) return;
      close(cont.querySelector('[data-c84-qa].is-open'));
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();
